import { Button, Group, LoadingOverlay, Stack, TextInput } from '@mantine/core';
import { useForm } from '@mantine/form';
import React from 'react';

import { DeviceDetailsType, useUpdateDevice } from '@portals/api/organizations';
import { ModalCenteredMediaLayout } from '@portals/core';
import { ModalProps } from '@portals/framework';

import roomSrc from '../../assets/img/room.svg';

export interface UpdateDeviceNameProps
  extends ModalProps<{ device: DeviceDetailsType }> {}

export function UpdateDeviceName({
  closeMe,
  data: { device },
}: UpdateDeviceNameProps) {
  const updateDevice = useUpdateDevice();

  const form = useForm<{ name: string }>({
    initialValues: {
      name: device.name,
    },
  });

  const onSubmit = (values: typeof form.values) => {
    updateDevice.mutate(
      {
        deviceId: device.id,
        spaceId: device.space_id,
        updatedDevice: {
          name: values.name,
        },
      },
      { onSuccess: closeMe }
    );
  };

  return (
    <ModalCenteredMediaLayout
      opened
      title="Name your device"
      onClose={closeMe}
      media={<img src={roomSrc} />}
    >
      <LoadingOverlay visible={updateDevice.isLoading} />

      <form onSubmit={form.onSubmit(onSubmit)}>
        <Stack>
          <Group grow mb="md">
            <TextInput
              {...form.getInputProps('name')}
              placeholder="Device Name"
              required
            />
          </Group>

          <Group grow>
            <Button
              type="submit"
              disabled={!form.isValid || !form.values.name}
              loading={updateDevice.isLoading}
            >
              Submit
            </Button>
          </Group>
        </Stack>
      </form>
    </ModalCenteredMediaLayout>
  );
}
